import { ColorItemSchemeClass, ColorSchemeClass } from '../../../theme.const';
import {
  SettingsFilterView,
  ThemeOption,
  ThemeSettingsSection,
  SettingsLeaseType,
  LeaseRateSelection,
} from './settings.model';

/** Array of theme colors */
export const THEME_COLORS: ColorItemSchemeClass[] = [
  ColorItemSchemeClass.Expire12,
  ColorItemSchemeClass.Expire24,
  ColorItemSchemeClass.Expire36,
  ColorItemSchemeClass.Expire48,
  ColorItemSchemeClass.ExpireLong,
  ColorItemSchemeClass.ExpireNA,
];

/** Array of theme settings that holds an object per view */
export const THEME_VIEW_ITEMS: ThemeSettingsSection[] = [
  {
    key: SettingsFilterView.Expiry,
    value: 'filters.leaseExpiry',
  },
  {
    key: SettingsFilterView.Industry,
    value: 'filters.industry',
  },
  {
    key: SettingsFilterView.Occupiers,
    value: 'filters.occupier',
  },
];

/** Array of theme options. Holds color scheme options and labels */
export const THEME_OPTIONS: ThemeOption[] = [
  {
    key: ColorSchemeClass.Schema1,
    value: 'exportAndSettings.theme',
  },
  {
    key: ColorSchemeClass.Schema2,
    value: 'exportAndSettings.theme',
  },
  {
    key: ColorSchemeClass.Schema3,
    value: 'exportAndSettings.theme',
  },
  {
    key: ColorSchemeClass.Schema4,
    value: 'exportAndSettings.theme',
  },
  {
    key: ColorSchemeClass.Schema5,
    value: 'exportAndSettings.theme',
  },
];

export const LEASE_RATE_OPTS: LeaseRateSelection[] = [
  {
    key: SettingsLeaseType.BaseRent,
    value: 'exportAndSettings.leaseRateOpts.baseRent',
  },
  {
    key: SettingsLeaseType.EffectiveRent,
    value: 'exportAndSettings.leaseRateOpts.effectiveRent',
  },
  {
    key: SettingsLeaseType.AskingRent,
    value: 'exportAndSettings.leaseRateOpts.askingRent',
  },
];
